export const LEGAL_FILE_SECTIONS = [
  {
    segment: "legalFile",
    title: "Gestionar",
    iconKey: "assignment",
    permission: "expediente",
    match: "exact",
    home: {
      show: true,
      color: "#2563eb",
      description: "Gestión y administración de expedientes",
    },
  },
  {
    segment: "legalFile/news",
    title: "Novedades",
    iconKey: "newspaper",
    permission: "novedades",
    match: "prefix",
    home: {
      show: true,
      color: "#0ea5e9",
      description: "Gestión y administración de novedades",
    },
  },
  {
    segment: "legalFile/attachments",
    title: "Escritos",
    iconKey: "attachment",
    permission: "archivos adjuntos expedientes",
    match: "prefix",
    home: {
      show: true,
      color: "#64748b",
      description: "Archivos y escritos del expediente",
    },
  },
  {
    segment: "legalFile/documents",
    title: "Adjuntos",
    iconKey: "documents",
    permission: "ver documentos expedientes",
    match: "prefix",
    home: {
      show: true,
      color: "#f59e0b",
      description: "Documentos cargados en los expedientes",
    },
  },
  {
    segment: "legalFile/parties",
    title: "Partes y Clientes",
    iconKey: "parties",
    permission: "partes legales",
    match: "prefix",
    home: {
      show: true,
      color: "#4a78b9",
      description: "Partes legales y clientes agrupados",
    },
  },
  {
    segment: "legalFile/judicial/accounts",
    title: "Cuentas Judiciales",
    iconKey: "judicialAccounts",
    permission: "cuentas judiciales",
    match: "prefix",
    home: {
      show: true,
      color: "#379a57",
      description: "Gestión y administración de cuentas judiciales",
    },
  },
  {
    segment: "legalFile/notification/certificates",
    title: "Cédulas de Notificación",
    iconKey: "certificatesNotifications",
    permission: "cedulas notificacion",
    match: "prefix",
    home: {
      show: true,
      color: "#3ba5a5",
      description: "Gestión y administración de cédulas",
    },
  },
  {
    segment: "legalFile/report/menu",
    title: "Reportes",
    iconKey: "fileOpen",
    permission: "reporte",
    match: "prefix",
    home: {
      show: true,
      color: "#8b5cf6",
      description: "Reportes y exportaciones del módulo",
    },
  },
];
